import { apiClient } from './apiClient';

export const visitService = {
  // Get all visits
  async getVisits() {
    return apiClient.get(`/api/cmms/visits`);
  },

  // Get visits by contract
  async getVisitsByContract(contractId) {
    return apiClient.get(`/api/cmms/visits/contract/${contractId}`);
  },

  // Get visits by status
  async getVisitsByStatus(status) {
    return apiClient.get(`/api/cmms/visits/status/${status}`);
  },

  // Get upcoming visits
  async getUpcomingVisits() {
    return apiClient.get(`/api/cmms/visits/upcoming`);
  },

  // Get overdue visits
  async getOverdueVisits() {
    return apiClient.get(`/api/cmms/visits/overdue`);
  },

  // Get visits between dates
  async getVisitsBetweenDates(startDate, endDate) {
    return apiClient.get(`/api/cmms/visits/between?startDate=${startDate}&endDate=${endDate}`);
  },

  // Get single visit by ID
  async getVisitById(id) {
    return apiClient.get(`/api/cmms/visits/${id}`);
  },

  // Create new visit
  async createVisit(data) {
    return apiClient.post(`/api/cmms/visits`, data);
  },

  // Update visit
  async updateVisit(id, data) {
    return apiClient.put(`/api/cmms/visits/${id}`, data);
  },

  // Update visit status
  async updateVisitStatus(id, status, actualDate = null, notes = null) {
    return apiClient.put(`/api/cmms/visits/${id}/status`, {
      status,
      actualDate,
      notes,
    });
  },

  // Delete visit
  async deleteVisit(id) {
    return apiClient.delete(`/api/cmms/visits/${id}`);
  },
};
